import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import RelanceDevisModel from "../models/RelanceDevisModel";

export const base_url = "http://localhost:8000/api/v1/";

// ✅ Hook personnalisé pour récupérer les relances devis avec pagination
export function useGetRelanceDevis() {
    const [relances, setRelances] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [perPage] = useState(5);

    const [pagination, setPagination] = useState({
        total: 0,
        per_page: perPage,
        current_page: 1,
        last_page: 1,
    });

    const token = useSelector((state) => state.auth.token);
    const navigate = useNavigate();

    const fetchRelances = useCallback(
        async (customPage = 1) => {
            if (!token) {
                navigate("/login");
                return;
            }

            setLoading(true);
            try {
                const response = await fetch(
                    `${base_url}relances/devis`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                        body: JSON.stringify({
                            page: customPage,
                            per_page: perPage,
                        }),

                    }
                );

                if (!response.ok) throw new Error("Erreur lors de la récupération des relances devis");

                const data = await response.json();
                const relancesFormatées = data.relances.map((item) => new RelanceDevisModel(item));

                setRelances(relancesFormatées);
                setPagination({
                    total: data.total,
                    per_page: data.per_page,
                    current_page: data.current_page,
                    last_page: Math.ceil(data.total / data.per_page),
                });
            } catch (error) {
                console.error("Erreur:", error);
                setRelances([]);
            } finally {
                setLoading(false);
            }
        },
        [token, navigate, pagination.per_page, perPage]
    );

    useEffect(() => {
        fetchRelances(page);
    }, [fetchRelances, page]);

    return {
        relances,
        loading,
        pagination,
        page,
        setPage,
        fetchRelances,
        setRelances,
        setLoading,
        setPagination,
    };
}

// ✅ Fonction pour récupérer une relance devis par ID
export async function getRelanceDevisById(id, token) {
    if (!token) throw new Error("Utilisateur non authentifié");

    try {
        const response = await fetch(`${base_url}relances/devis/${id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) throw new Error("Erreur lors de la récupération de la relance devis");

        const data = await response.json();
        return new RelanceDevisModel(data.relance);
    } catch (error) {
        console.error("Erreur getRelanceDevisById:", error);
        return null;
    }
}
